import React from "react";
import { Building2, CalendarCheck, RefreshCw } from "lucide-react";

export default function SeoGrowthFreshness({ freshness }) {
  const items = [
    { icon: CalendarCheck, label: "Effective from", value: freshness.effective },
    { icon: Building2, label: "Responsible authority", value: freshness.authority },
    { icon: RefreshCw, label: "What changed", value: freshness.changed }
  ];
  return (
    <section className="grid gap-4 md:grid-cols-3">
      {items.map(({ icon: Icon, label, value }) => (
        <div key={label} className="rounded-3xl border border-border bg-card p-5 shadow-lg">
          <Icon className="mb-3 h-5 w-5 text-primary" />
          <p className="text-xs font-black uppercase tracking-wider text-muted-foreground">{label}</p>
          <p className="mt-2 text-sm font-bold leading-6 text-foreground">{value}</p>
        </div>
      ))}
    </section>
  );
}